const modal_link = document.querySelectorAll('[data-modalloc]');
const modal = document.querySelectorAll('.loc-list__modal');

if (!!modal) {
  modal_link.forEach(e => {
    e.addEventListener('click', event => {
      event.preventDefault();
      const modal_item = document.getElementById(e.dataset.modalloc);
      modal_item.classList.add('active');
    });
  });

  modal.forEach(e => {
    e.addEventListener('click', click => {
      if (click.target == e || click.target.classList.contains('loc-list__modal-close')) {
        e.classList.remove('active');
      }
    });
  });
}
